module.exports = __webpack_public_path__ + "d83dc595c6a175c8a7f9e3f75da845ad.png";